import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSettings } from '../shared/app-settings';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class ActivateService implements CanActivate {
    constructor(private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem(AppSettings.StorageKeys.Token)) {
            const userStr = localStorage.getItem(AppSettings.StorageKeys.User);
            const user = userStr ? JSON.parse(userStr) : null;
            const isExternalUser = !!user?.isExternalUser;
            const requestedUrl = (state?.url || '').toLowerCase();
            const externalAllowedPrefixes = ['/projects', '/my-profile', '/change-password', '/info'];
            // Redirect external users accessing root path to projects
            if (isExternalUser && (requestedUrl === '' || requestedUrl === '/')) {
                this.router.navigate(['/projects']);
                return of(false);
            }


            if (isExternalUser && !externalAllowedPrefixes.some(prefix => requestedUrl.startsWith(prefix))) {
                this.router.navigate(['/projects/external-no-access']);
                return of(false);
            }

            if (route.data['adminPage'] == true && this.getUserLevel() == false)
                return of(false);
            return of(true);
        }
        else {
            this.router.navigate(['/login']);
            return of(false);
        }
    }

    getUserLevel() {
        try {
            const userStr = localStorage.getItem(AppSettings.StorageKeys.User);
            if (!userStr) return false;
            const user = JSON.parse(userStr);
            const userAccess: any[] = user.userAccess || [];
            // adminPage routes use moduleId 99 — check module access
            return userAccess.some((a: any) => a.moduleID === 99 && (a.new === true || a.new === 1));
        } catch {
            return false;
        }
    }
}
